import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@components/button';
import { CsIconModule } from '@components/icon';
import { IncompleteChatSheetComponent } from './incomplete-chat-sheet.component';
import { DirectivesModule } from '@directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        CsIconModule,
        FormsModule,
        DirectivesModule,
    ],
  declarations: [IncompleteChatSheetComponent],
  exports: [IncompleteChatSheetComponent],
})
export class IncompleChatSheetModule { }
